import { isRejected } from "@reduxjs/toolkit";
import { format } from "date-fns";
import { getResourcesState } from "entities/hallmap";
import { selectResources, selectResourcesState } from "entities/hallmap/model/selectors";
import { TResourceState } from "entities/hallmap/model/types";
import { Order, toEndVisitOrder } from "entities/orders";
import { selectPlaces } from "entities/toolbar/places";
import { getTimeslots, selectSelectedTimeslot } from "entities/toolbar/timeslots";
import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { formatWithLocale } from "shared/lib/datepicker";
import { useAppDispatch, useAppSelector } from "shared/lib/store";

export type ResourceForRender = {
	id: number;
	is_active: boolean;
	name: string;
	notes?: string;
  order: Order;
	place: number;
	resource_type: number;
  state: TResourceState;
	uid: string;
	use_by: string;
}

export interface IHall {
  name: string;
  items: ResourceForRender[];
}

export const useMobileSitting = () => {
  const dispatch = useAppDispatch();

  const places = useAppSelector(selectPlaces);
  const resources = useAppSelector(selectResources);
  const resourcesState = useAppSelector(selectResourcesState);
  const selectedTimeslot = useAppSelector(selectSelectedTimeslot);

  const [ resourcesForRender, setResourcesForRender ] = useState<IHall[]>([]);
  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  const toastId = useRef<string|number>(0)

  const setResourcesForRenderArr = useCallback(() => {

    const arr = resourcesState.filter(el=>(el.state==='busy'||el.state==='ending'||el.state==='exceeding')&&el.order).map(el=>{
      let obj = el;

      const finded = resources.find(recource=>{
        if (recource.id === el.id) {
          return recource;
        }
      })

      if (finded) {
        obj = {
          ...obj,
          ...finded,
        }
      }

      return obj as ResourceForRender;
    }) as ResourceForRender[];

    const halls = places.map(place=>{
      const items = arr.filter(item=>item.place === place.id);

      return {
        name: place.name,
        items,
      }
    }) as IHall[];

    setResourcesForRender(halls);
  }, [
    places,
    resources,
    resourcesState,
  ])

  const getCurrTimeSlot = useCallback(()=>{
    if (selectedTimeslot?.trim()) {
      return selectedTimeslot
    }

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const date = currentDate.getDate();
    const hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();

    if (minutes < 15) {
      minutes = 0
    }
    if (minutes > 15 && minutes < 30) {
      minutes = 15
    }
    if (minutes > 30 && minutes < 45) {
      minutes = 30
    }
    if (minutes > 45 && minutes < 59) {
      minutes = 45
    }
    // if (minutes > 45) {
    //   ++hours;
    //   minutes = 0
    // }
    const today = new Date(year, month, date, hours, minutes)

    const offset = today.getTimezoneOffset();
    const offsetHours = Math.abs(offset) / 60;
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetStr = `${offset > 0 ? '-' : '+'}${offsetHours > 9 ? offsetHours : `0${offsetHours}`}:${offsetMinutes > 9 ? offsetMinutes : `0${offsetMinutes}`}`;
    const str = format(today, `yyyy-MM-dd'T'HH:mm:ss${offsetStr}`)

    return str;
  }, [selectedTimeslot])
  
  const loadState = useCallback(async () => {
    if (!getCurrTimeSlot()?.trim()) {
      return;
    }

    await dispatch(
      getResourcesState({ dt_requested: getCurrTimeSlot() }),
    );
  }, [getCurrTimeSlot, dispatch])
  
  useEffect(() => {
    setResourcesForRenderArr()
  }, [
    places,
    resources,
    resourcesState,
    setResourcesForRenderArr
  ])

  const onEndVisitClick = useCallback(async (id: number) => {
    setIsLoading(true);
    const result = await dispatch(toEndVisitOrder({id}))
    if (toastId.current) {
      toast.dismiss(toastId.current);
    }
    if (!isRejected(result)) {
      toastId.current = toast.success('Визит успешно завершен');
      await dispatch(getTimeslots({date_slot: formatWithLocale(new Date(), 'yyyy-MM-dd')}));
      await loadState();
    } else {
      toastId.current = toast.warning('Что-то пошло не так, попробуйте ещё раз чуть позже')
    }
    setIsLoading(false);
  }, [dispatch, loadState])

  return {
    resourcesForRender,
    onEndVisitClick,
    isLoading
  }
}